import {
    AppConfigurationType, Privilege,
} from './types';
import { isObjectValidAndNotEmpty } from '../utils/nullChecks';
import { getStringFromObject } from '../utils/lodash';
import { MapKV, RouteName } from '../types/commonTypes';
import checkIfPrivilegeExistsForUser from '../utils/privilegeChecker';
import { PAGE_ROUTES } from '../utils/constants';

export const userHasPrivilege = (
    privilege: Privilege,
    appConfiguration: AppConfigurationType | null,
) => {
    if (!isObjectValidAndNotEmpty<AppConfigurationType>(appConfiguration)) {
        return false;
    }
    const privilegesToCheck = appConfiguration.privileges[privilege];
    return checkIfPrivilegeExistsForUser(privilegesToCheck);
};

export const userHasTabPrivilege = (
    navigationTab: RouteName,
    appConfiguration: AppConfigurationType | null,
) => {
    if (!isObjectValidAndNotEmpty<AppConfigurationType>(appConfiguration)) {
        return false;
    }
    const privilegesToCheck = appConfiguration.tabPrivileges[navigationTab];
    return checkIfPrivilegeExistsForUser(privilegesToCheck);
};

export const getFirstRouteForUsersPrivileges = (
    tabs: Array<RouteName>,
    appConfiguration: AppConfigurationType | null,
) => {
    for (let index = 0; index < tabs.length; index += 1) {
        const aTab = tabs[index];
        if (userHasTabPrivilege(aTab, appConfiguration)) {
            return PAGE_ROUTES[aTab];
        }
    }
    return PAGE_ROUTES.BRANCHES;
};

export const getGlobalPropertyValue = (
    globalProperties: MapKV | null,
    property: string,
    defaultValue?: unknown,
) => {
    if (!isObjectValidAndNotEmpty(globalProperties)) {
        return defaultValue;
    }
    const propertyName = property.replace(/\./g, '_');
    return getStringFromObject(propertyName, globalProperties, defaultValue);
};
